import React, { Component } from 'react';
import { connect } from 'react-redux';
import EventItemListModal from '../../../../views/app/common/modal/EventItemListModal';
import withModal from '../../../../lib/hoc/withModal';
import { appActions } from '../../../../store/modules/app';
import { LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';

class EventItemListModalContainer extends Component {
  componentDidMount = () => {
    const { data } = this.props;
    const { pagination } = data.listData;
    this.getEventItemList({
      pagination,
    });
  };

  /**
   * 모달 닫기 || 데이터 초기화
   */
  closeModal = () => {
    this.props.toggleModal({
      name: 'eventItemListModal',
      data: {
        listData: {
          list: [],
          pagination: LIST_PAGINATION_MODEL,
        },
        eventId: null,
      },
      value: false,
    });
  };

  /**
   * 기획전 리스트 가져오기
   */
  getEventItemList = (option) => {
    const { pagination } = option;
    const { getEventItemList, data } = this.props;
    const { eventId } = data;
    getEventItemList({
      pagination,
      eventId,
    });
  };

  render() {
    return (
      <EventItemListModal
        {...this.state}
        {...this.props}
        closeModal={this.closeModal}
        getEventItemList={this.getEventItemList}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.app.eventItemListModal.isOpen,
    data: state.app.eventItemListModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: appActions.appToggleModal,
  getEventItemList: appActions.getEventItemList,
  getProductSubCategoryList: appActions.getProductSubCategoryList,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(EventItemListModalContainer));
